import _regeneratorRuntime from "D:\\Proyectos\\Pronox\\Pronox\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import e, { useContext as t, useState as r, useMemo as n, useEffect as a, Fragment as u } from "react";
import { Row as o, Col as i, Input as c, Button as s, Icon as l, Tooltip as p, Popconfirm as f, Table as m, DatePicker as d, InputNumber as y, Switch as h, Radio as g, Select as v, Upload as b, Cascader as k, Form as w } from "antd";
import "prop-types";
import x from "moment";
import { EditorState as O, convertFromRaw as E, ContentState as R, convertToRaw as j } from "draft-js";
import { Editor as C } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

function S(e) {
  return (S = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}

function P(e, t, r, n, a, u, o) {
  try {
    var i = e[u](o),
        c = i.value;
  } catch (e) {
    return void r(e);
  }

  i.done ? t(c) : Promise.resolve(c).then(n, a);
}

function q(e) {
  return function () {
    var t = this,
        r = arguments;
    return new Promise(function (n, a) {
      var u = e.apply(t, r);

      function o(e) {
        P(u, n, a, o, i, "next", e);
      }

      function i(e) {
        P(u, n, a, o, i, "throw", e);
      }

      o(void 0);
    });
  };
}

function N(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

function F() {
  return (F = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function L(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {},
        n = Object.keys(r);
    "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
      return Object.getOwnPropertyDescriptor(r, e).enumerable;
    }))), n.forEach(function (t) {
      N(e, t, r[t]);
    });
  }

  return e;
}

function K(e, t) {
  if (null == e) return {};

  var r,
      n,
      a = function (e, t) {
    if (null == e) return {};
    var r,
        n,
        a = {},
        u = Object.keys(e);

    for (n = 0; n < u.length; n++) {
      r = u[n], t.indexOf(r) >= 0 || (a[r] = e[r]);
    }

    return a;
  }(e, t);

  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);

    for (n = 0; n < u.length; n++) {
      r = u[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (a[r] = e[r]);
    }
  }

  return a;
}

function T(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var r = [],
        n = !0,
        a = !1,
        u = void 0;

    try {
      for (var o, i = e[Symbol.iterator](); !(n = (o = i.next()).done) && (r.push(o.value), !t || r.length !== t); n = !0) {
        ;
      }
    } catch (e) {
      a = !0, u = e;
    } finally {
      try {
        n || null == i.return || i.return();
      } finally {
        if (a) throw u;
      }
    }

    return r;
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }();
}

function Q(e) {
  return function (e) {
    if (Array.isArray(e)) {
      for (var t = 0, r = new Array(e.length); t < e.length; t++) {
        r[t] = e[t];
      }

      return r;
    }
  }(e) || function (e) {
    if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }();
}

var D = e.createContext(null),
    V = function V(e, t, r, n) {
  return "function" == typeof r ? r(t) || n : t[e] || n;
},
    B = function B(t) {
  var r = t.selectedKeys,
      n = t.setSelectedKeys,
      a = t.confirm,
      u = t.clearFilters,
      l = t.translation,
      p = void 0 === l ? function (e) {
    return e;
  } : l;
  return e.createElement(o, {
    gutter: 8,
    className: "custom-search-filter"
  }, e.createElement(i, {
    span: 24,
    style: {
      paddingBottom: 8
    }
  }, e.createElement(c.Search, {
    value: r[0],
    onChange: function onChange(e) {
      return n(e.target.value ? [e.target.value] : []);
    },
    onPressEnter: function onPressEnter() {
      return a();
    },
    placeholder: p ? p("Search") : "Search"
  })), e.createElement(i, {
    span: 12,
    className: "custom-align-right"
  }, e.createElement(s, {
    htmlType: "button",
    type: "primary",
    ghost: !0,
    onClick: function onClick() {
      return a();
    }
  }, p ? p("Ok") : "Ok")), e.createElement(i, {
    span: 12
  }, e.createElement(s, {
    htmlType: "button",
    onClick: function onClick() {
      return u();
    }
  }, p ? p("Reset") : "Reset")));
};

B.defaultProps = {
  translation: function translation(e) {
    return e;
  }
};

var A = function A(t) {
  var r = t.selectedKeys,
      n = t.setSelectedKeys,
      a = t.confirm,
      u = t.clearFilters,
      l = t.translation;
  return e.createElement(o, {
    gutter: 8,
    className: "custom-search-filter"
  }, e.createElement(i, {
    span: 24,
    style: {
      paddingBottom: 8
    }
  }, e.createElement(c.Search, {
    value: r[0],
    onChange: function onChange(e) {
      return n(e.target.value ? [e.target.value] : []);
    },
    onPressEnter: function onPressEnter() {
      return a();
    },
    placeholder: l ? l("Search") : "Search"
  })), e.createElement(i, {
    span: 12,
    className: "custom-align-right"
  }, e.createElement(s, {
    htmlType: "button",
    type: "primary",
    ghost: !0,
    onClick: function onClick() {
      return a();
    }
  }, l ? l("Ok") : "Ok")), e.createElement(i, {
    span: 12
  }, e.createElement(s, {
    htmlType: "button",
    onClick: function onClick() {
      return u();
    }
  }, l ? l("Reset") : "Reset")));
};

A.defaultProps = {
  translation: function translation(e) {
    return e;
  }
};

var z = {
  getList: function () {
    var e = q(_regeneratorRuntime.mark(function e(t, r) {
      var n;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, t.get(r);

            case 2:
              return n = e.sent, e.abrupt("return", n.data);

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r) {
      return e.apply(this, arguments);
    };
  }(),
  getByKey: function () {
    var e = q(_regeneratorRuntime.mark(function e(t, r, n, a) {
      var u;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, t.get(r, a);

            case 2:
              return u = e.sent, e.abrupt("return", u.data);

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r, n, a) {
      return e.apply(this, arguments);
    };
  }(),
  upsert: function () {
    var e = q(_regeneratorRuntime.mark(function e(t, r, n, a, u) {
      var o;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, t[u.method || "post"](r, a);

            case 2:
              return o = e.sent, e.abrupt("return", o.data);

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r, n, a, u) {
      return e.apply(this, arguments);
    };
  }(),
  create: function () {
    var e = q(_regeneratorRuntime.mark(function e(t, r, n, a, u) {
      var o;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, t[u.method || "post"](r, a);

            case 2:
              return o = e.sent, e.abrupt("return", o.data);

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r, n, a, u) {
      return e.apply(this, arguments);
    };
  }(),
  update: function () {
    var e = q(_regeneratorRuntime.mark(function e(t, r, n, a, u) {
      var o;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, t[u.method || "put"](r, a);

            case 2:
              return o = e.sent, e.abrupt("return", o.data);

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r, n, a, u) {
      return e.apply(this, arguments);
    };
  }(),
  delete: function () {
    var e = q(_regeneratorRuntime.mark(function e(t, r, n, a, u) {
      var o;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, t[u.method || "delete"](r, a);

            case 2:
              return o = e.sent, e.abrupt("return", o.data);

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r, n, a, u) {
      return e.apply(this, arguments);
    };
  }(),
  getForField: function () {
    var e = q(_regeneratorRuntime.mark(function e(t, r, n, a, u) {
      var o, i;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return o = u.method || "get", e.next = 3, t[o](r, "get" === o ? {
                params: a
              } : a);

            case 3:
              return i = e.sent, e.abrupt("return", i.data);

            case 5:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r, n, a, u) {
      return e.apply(this, arguments);
    };
  }()
},
    U = {
  getList: function () {
    var e = q(_regeneratorRuntime.mark(function e(t, r, n) {
      var a;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, t.query({
                query: r
              });

            case 2:
              return a = e.sent, e.abrupt("return", a.data[n]);

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r, n) {
      return e.apply(this, arguments);
    };
  }(),
  getByKey: function () {
    var e = q(_regeneratorRuntime.mark(function e(t, r, n, a) {
      var u;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, t.query({
                query: r,
                variables: a
              });

            case 2:
              return u = e.sent, e.abrupt("return", u.data[n]);

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r, n, a) {
      return e.apply(this, arguments);
    };
  }(),
  upsert: function () {
    var e = q(_regeneratorRuntime.mark(function e(t, r, n, a, u) {
      var o;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, t.mutate({
                mutation: r,
                variables: a,
                refetchQueries: u.refetchQueries
              });

            case 2:
              return o = e.sent, e.abrupt("return", o.data[n]);

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r, n, a, u) {
      return e.apply(this, arguments);
    };
  }(),
  create: function () {
    var e = q(_regeneratorRuntime.mark(function e(t, r, n, a, u) {
      var o;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, t.mutate({
                mutation: r,
                variables: a,
                refetchQueries: u.refetchQueries
              });

            case 2:
              return o = e.sent, e.abrupt("return", o.data[n]);

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r, n, a, u) {
      return e.apply(this, arguments);
    };
  }(),
  update: function () {
    var e = q(_regeneratorRuntime.mark(function e(t, r, n, a, u) {
      var o;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, t.mutate({
                mutation: r,
                variables: a,
                refetchQueries: u.refetchQueries
              });

            case 2:
              return o = e.sent, e.abrupt("return", o.data[n]);

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r, n, a, u) {
      return e.apply(this, arguments);
    };
  }(),
  delete: function () {
    var e = q(_regeneratorRuntime.mark(function e(t, r, n, a, u) {
      var o;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, t.mutate({
                mutation: r,
                variables: a,
                refetchQueries: u.refetchQueries
              });

            case 2:
              return o = e.sent, e.abrupt("return", o.data[n]);

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r, n, a, u) {
      return e.apply(this, arguments);
    };
  }(),
  getForField: function () {
    var e = q(_regeneratorRuntime.mark(function e(t, r, n, a) {
      var u;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, t.query({
                query: r,
                variables: a
              });

            case 2:
              return u = e.sent, e.abrupt("return", u.data[n]);

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r, n, a) {
      return e.apply(this, arguments);
    };
  }()
},
    I = Object.freeze({
  rest: z,
  graphql: U
}),
    _ = {
  string: function string(e, t) {
    return function (r, n) {
      return V(e, r, t, "").localeCompare(V(e, n, t, ""));
    };
  },
  number: function number(e, t) {
    return function (r, n) {
      return V(e, r, t) - V(e, n, t);
    };
  },
  bool: function bool(e, t) {
    return function (r, n) {
      return V(e, n, t, !1) - V(e, r, t, !1);
    };
  }
},
    M = function M(e) {
  return "radio" !== e.type && "select" !== e.type || e.render ? "bool" !== e.type || e.render ? e.render = e.columnKey ? function (t, r) {
    return r[e.columnKey] || t;
  } : e.render : e.render = function (t, r) {
    return r[e.key] ? e.options.true : e.options.false;
  } : e.render = function (t, r) {
    return e.columnKey ? r[e.columnKey] : e.options[t] || t;
  }, e.render;
},
    W = function W(t) {
  return e.createElement(l, {
    type: "search",
    style: {
      color: t ? "white" : "black",
      background: t ? "#1890ff" : void 0
    }
  });
},
    G = function G(e, t) {
  var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "";
  return "function" == typeof e.getValue ? e.getValue(t) || r : t[e.columnKey || e.key] || r;
},
    H = function H(t, r) {
  return t.filter(function (e) {
    return !(Object.hasOwnProperty.call(e, "hidden") && e.hidden.includes("column"));
  }).map(function (t) {
    return L({
      title: t.title || "",
      key: t.key,
      dataIndex: t.key,
      sorter: !0 === t.sorter && (_[t.type] ? _[t.type](t.key, t.getValue) : _.string(t.key, t.getValue)),
      render: M(t)
    }, t.columnStyle || {}, function (t, r) {
      if (!0 === t.filter) switch (t.filterType || t.type) {
        case "date":
        case "number":
        case "select":
        case "textarea":
        case "string":
          return {
            filterDropdown: function filterDropdown(n) {
              return "date" === t.type ? e.createElement(A, F({}, n, {
                translation: r
              })) : e.createElement(B, F({}, n, {
                translation: r
              }));
            },
            filterIcon: W,
            onFilter: function onFilter(e, r) {
              return G(t, r).toString().toLowerCase().includes(e.toLowerCase());
            }
          };

        case "checkbox":
        case "radio":
          var n = Object.keys(t.options);
          return {
            filters: n.map(function (e) {
              return {
                value: e,
                text: t.options[e]
              };
            }),
            filterMultiple: n.length > 2,
            onFilter: function onFilter(e, r) {
              return 0 === G(t, r).indexOf(e);
            }
          };

        case "bool":
          return {
            filters: Object.keys(t.options).map(function (e) {
              return {
                value: e,
                text: t.options[e]
              };
            }),
            filterMultiple: !1,
            onFilter: function onFilter(e, r) {
              return G(t, r, !1).toString() === e;
            }
          };

        default:
          return {};
      }
    }(t, r) || {});
  });
};

function J(e, u) {
  var o = t(D),
      i = o.client,
      c = o.type,
      s = T(r([]), 2),
      l = s[0],
      p = s[1],
      f = T(r(!1), 2),
      m = f[0],
      d = f[1],
      y = n(function () {
    return H(e.fields, u);
  }, [e.fields, u]);
  a(function () {
    d(!0);
    var t = "graphql" === c ? i.watchQuery({
      query: e.getList.query
    }).subscribe({
      next: function next(t) {
        var r = t.data;
        p(r[e.getList.accessData] || []);
      }
    }) : {
      _cleanup: function _cleanup() {}
    };
    return I[c].getList(i, e.getList.query || e.getList.url, e.getList.accessData || null).then(function (e) {
      d(!1), p(e);
    }).catch(function (e) {
      d(!1), console.log(e);
    }), function () {
      return t._cleanup && t._cleanup();
    };
  }, [i, e.getList, c]);
  return {
    columns: y,
    dataSource: l,
    onDelete: function onDelete(t) {
      var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function () {};
      d(!0);
      var n = [{
        query: e.getList.query || null
      }];
      e.getQueriesUpdate && e.getQueriesUpdate.length > 0 && e.getQueriesUpdate.forEach(function (e) {
        return n.push({
          query: e.query || null
        });
      }), I[c].delete(i, e.delete.query || e.delete.url.replace("{keyName}", t || ""), e.delete.accessData || null, N({}, e.keyName || "id", t), {
        refetchQueries: n,
        method: e.delete.method || void 0
      }).then(function (n) {
        n && console.log("ok"), d(!1), "rest" === c && p(l.filter(function (r) {
          return r[e.keyName] !== t;
        })), r(n);
      }).catch(function (e) {
        d(!1), console.log(e);
      });
    },
    loading: m
  };
}

var X = function X(e) {
  return Object.keys(e).forEach(function (t) {
    "string" == typeof e[t] && (e[t] = e[t].trim());
  }), e;
},
    Y = function () {
  var e = q(_regeneratorRuntime.mark(function e(t, r) {
    var n,
        a,
        u,
        o = arguments;
    return _regeneratorRuntime.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            if (n = o.length > 2 && void 0 !== o[2] ? o[2] : Object.keys(r), a = o.length > 3 ? o[3] : void 0, !(t.dependencies && t.dependencies.fields.filter(function (e) {
              return n.includes(e);
            }).length > 0)) {
              e.next = 6;
              break;
            }

            return u = {}, Object.keys(r).forEach(function (e) {
              t.dependencies.fields.indexOf(e) >= 0 && (u[e] = r[e]);
            }), e.abrupt("return", t.dependencies && t.dependencies.onChange(u, t, a));

          case 6:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }));
  return function (t, r) {
    return e.apply(this, arguments);
  };
}(),
    Z = function Z(e, t, r) {
  var n = "object" === S(e) && null !== e && Object.hasOwnProperty.call(e, [t.configOptions && t.configOptions.keyName || r]) ? e[t.configOptions && t.configOptions.keyName || r] : e;

  switch (t.type) {
    case "date":
      return x(n);

    case "number":
      return n;

    case "radio":
    case "bool":
      return n || !1;

    case "select":
      return "multiple" === t.mode ? n && n.map(function (e) {
        return e[t.configOptions && t.configOptions.keyName || r];
      }) || [] : n && n.toString() || "";

    case "cascader":
      return [e[t.keyParent][t.configOptions && t.configOptions.keyName || r], e[t.configOptions && t.configOptions.keyName || r]];

    case "rich":
      return n || " ";

    default:
      return n && n.toString() || null;
  }
},
    $ = function $(e, t, r, n) {
  return r.dependencies && n[r.key] && Object.keys(n[r.key].options || {}).length > 0 ? n[r.key] && n[r.key].options || {} : e.keys[r.key] >= 0 && t[e.keys[r.key]] && "cascader" !== r.type ? t[e.keys[r.key]].data[r.configOptions.accessData].reduce(function (e, t) {
    return L({}, e, r.configOptions.map(t));
  }, {}) || {} : "cascader" === r.type ? t[e.keys[r.key]].data[r.configOptions.accessData].filter(function (e) {
    return e[r.keyChildren].length > 0;
  }) : r.options || {};
};

function ee(e, t) {
  return e.updateKey ? "function" == typeof e.updateKey ? e.updateKey(t) : t[e.updateKey] : t[e.key];
}

function te(e, n) {
  var u = T(r(!1), 2),
      o = u[0],
      i = u[1],
      c = T(r(!!n), 2),
      s = c[0],
      l = c[1],
      p = T(r(e.fields), 2),
      f = p[0],
      m = p[1],
      d = t(D),
      y = d.client,
      h = d.type,
      g = function () {
    var e = q(_regeneratorRuntime.mark(function e(t, r, n, a) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", I[h].getForField(y, t, n, r, {
                method: a
              }));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r, n, a) {
      return e.apply(this, arguments);
    };
  }();

  a(function () {
    function t() {
      return (t = q(_regeneratorRuntime.mark(function t() {
        var r, a, u, o, c;
        return _regeneratorRuntime.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.prev = 0, r = {}, a = {
                  all: [],
                  keys: {}
                }, u = 0, f.forEach(function (e) {
                  if (e.configOptions && "object" === S(e.configOptions.query)) {
                    var t = e.configOptions.query;
                    a.all.push(y.query({
                      query: t
                    })), a.keys[e.key] = u, u += 1;
                  }

                  "file" === e.type && (e.props.fileList = []);
                }), t.next = 7, Promise.all(a.all);

              case 7:
                if (o = t.sent, !n) {
                  t.next = 19;
                  break;
                }

                return l(!0), t.next = 12, I[h].getByKey(y, e.getByKey.query || e.getByKey.url.replace("{keyName}", n || ""), e.getByKey.accessData, N({}, e.keyName || "id", n));

              case 12:
                return c = t.sent, t.next = 15, Promise.all(f.map(function () {
                  var t = q(_regeneratorRuntime.mark(function t(r) {
                    var n, a, u;
                    return _regeneratorRuntime.wrap(function (t) {
                      for (;;) {
                        switch (t.prev = t.next) {
                          case 0:
                            if (n = ee(r, c), "file" === r.type && null !== n && (a = [{
                              uid: "".concat(n),
                              name: "".concat(n),
                              status: "done",
                              url: r.resolvePath(n)
                            }], r.props.fileList = a), !n) {
                              t.next = 7;
                              break;
                            }

                            return t.next = 5, Y(r, c, Object.keys(c), g);

                          case 5:
                            return u = t.sent, t.abrupt("return", L({
                              key: r.key
                            }, u, {
                              value: Z(n, r, e.keyName)
                            }));

                          case 7:
                            return t.abrupt("return", {
                              key: r.key,
                              value: Z(n, r, e.keyName)
                            });

                          case 8:
                          case "end":
                            return t.stop();
                        }
                      }
                    }, t);
                  }));
                  return function (e) {
                    return t.apply(this, arguments);
                  };
                }()));

              case 15:
                t.sent.forEach(function (e) {
                  r[e.key] = e;
                }), t.next = 20;
                break;

              case 19:
                f.forEach(function (e) {
                  r[e.key] = L({}, Y(e, {}, [], g), {
                    value: Z(e.initialValue || void 0, e)
                  });
                });

              case 20:
                m(f.map(function (e) {
                  var t = $(a, o, e, r);
                  return L({}, e, r[e.key] || {}, {
                    options: t
                  });
                })), n && l(!1), t.next = 27;
                break;

              case 24:
                t.prev = 24, t.t0 = t.catch(0), console.log(t.t0);

              case 27:
                i(!1);

              case 28:
              case "end":
                return t.stop();
            }
          }
        }, t, null, [[0, 24]]);
      }))).apply(this, arguments);
    }

    !function () {
      t.apply(this, arguments);
    }();
  }, [n]);

  var v = function () {
    var e = q(_regeneratorRuntime.mark(function e(t, r, n) {
      var a;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return a = Object.keys(r), e.t0 = m, e.next = 4, Promise.all(f.map(function () {
                var e = q(_regeneratorRuntime.mark(function e(u) {
                  var o, i, c;
                  return _regeneratorRuntime.wrap(function (e) {
                    for (;;) {
                      switch (e.prev = e.next) {
                        case 0:
                          if ("file" === u.type && a[0] === u.key && (o = r[a[0]], i = (i = (i = o && o.fileList ? Q(o.fileList) : []).slice(-2)).map(function (e) {
                            return e.response && (e.url = e.response.url), e;
                          }), u.props.fileList = i), u.dependencies && u.dependencies.fields.filter(function (e) {
                            return a.includes(e);
                          }).length > 0) {
                            e.next = 3;
                            break;
                          }

                          return e.abrupt("return", L({}, u, {
                            value: n[u.key]
                          }));

                        case 3:
                          return e.next = 5, Y(u, n, a, g);

                        case 5:
                          return (c = e.sent) && Object.hasOwnProperty.call(c, "value") && t.form.setFieldsValue(N({}, u.key, c.value)), e.abrupt("return", L({}, u, {
                            value: n[u.key]
                          }, c));

                        case 8:
                        case "end":
                          return e.stop();
                      }
                    }
                  }, e);
                }));
                return function (t) {
                  return e.apply(this, arguments);
                };
              }()));

            case 4:
              e.t1 = e.sent, (0, e.t0)(e.t1);

            case 6:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r, n) {
      return e.apply(this, arguments);
    };
  }();

  return {
    fields: f,
    onSubmit: function onSubmit(t) {
      var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function () {};
      i(!0), X(t);
      var a = null != n && "graphql" === h ? {
        query: e.getByKey.query,
        variables: N({}, e.keyName || "id", n || void 0)
      } : void 0,
          u = "upsert";
      Object.hasOwnProperty.call(e, "upsert") || (null != n && Object.hasOwnProperty.call(e, "update") ? u = "update" : !n && Object.hasOwnProperty.call(e, "create") && (u = "create"));
      var o = [{
        query: e.getList.query || null
      }, a];
      e.getQueriesUpdate && e.getQueriesUpdate.length > 0 && e.getQueriesUpdate.forEach(function (e) {
        return o.push({
          query: e.query || null
        });
      }), I[h][u](y, e[u].query || e[u].url.replace("{keyName}", n || ""), e[u].accessData || null, L({}, t, N({}, e.keyName || "id", n || void 0)), {
        method: e[u].method,
        refetchQueries: o.filter(Boolean)
      }).then(function (e) {
        i(!1), r(e);
      }).catch(function (e) {
        i(!1), console.log(e);
      });
    },
    loading: o,
    onValuesChanged: v,
    loadingForm: s
  };
}

var re = function re(t) {
  var r = t.title,
      n = t.columns,
      a = t.dataSource,
      c = t.addButtons,
      l = t.addActions,
      d = t.translation,
      y = K(t, ["title", "columns", "dataSource", "addButtons", "addActions", "translation"]),
      h = Q(n);
  return l && l.length > 0 && h.push({
    title: d("Actions"),
    key: "",
    align: "right",
    width: 50 * (l && l.length || 0),
    render: function render(t, r) {
      return l && l.map(function (t) {
        return e.createElement(p, {
          key: t.icon,
          title: t.text
        }, " ", t.confirm ? e.createElement(f, {
          title: t.confirm,
          okText: t.okText || "Ok",
          cancelText: t.cancelText || "Cancel",
          placement: "bottomRight",
          onConfirm: function onConfirm() {
            return t.onClick(r);
          }
        }, e.createElement(s, {
          type: t.type || "ghost",
          shape: "circle",
          icon: t.icon
        })) : e.createElement(s, {
          type: t.type || "ghost",
          shape: "circle",
          icon: t.icon,
          onClick: function onClick() {
            return t.onClick(r);
          }
        }));
      });
    }
  }), e.createElement(u, null, e.createElement(o, {
    type: "flex",
    align: "middle",
    justify: "space-between"
  }, e.createElement(i, null, r), e.createElement(i, null, c && c.map(function (t, r) {
    return e.createElement(u, {
      key: r
    }, e.createElement(s, F({
      size: "large",
      type: "primary"
    }, t), t.text), " ");
  }))), e.createElement(m, F({
    scroll: {
      x: !0
    },
    columns: h,
    dataSource: a,
    className: "custom-table"
  }, y)));
};

re.defaultProps = {
  dataSource: [],
  translation: function translation(e) {
    return e;
  }
};

var ne = function ne(e, t) {
  return t(e.getCurrentContent(), j);
},
    ae = function ae(n) {
  var u = n.onChange,
      o = n.value,
      i = n.typeFormat,
      c = n.convertToRaw,
      s = n.convertToDraft,
      l = n.toolbar,
      p = t(D).localize,
      f = T(r(O.createEmpty()), 2),
      m = f[0],
      d = f[1];
  return a(function () {
    "markdown" === i ? d(function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
          t = arguments.length > 1 ? arguments[1] : void 0;
      return O.createWithContent(t(e, E));
    }(o, s)) : "html" === i && d(function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : " ",
          t = (arguments.length > 1 ? arguments[1] : void 0)(e);

      if (t) {
        var r = R.createFromBlockArray(t.contentBlocks);
        return O.createWithContent(r);
      }
    }(o, s));
  }, []), e.createElement(C, {
    editorState: m,
    wrapperClassName: "custom-rich-wrapper",
    editorClassName: "custom-rich-editor",
    onEditorStateChange: function onEditorStateChange(e) {
      var t = ne(e, c);
      u(t), d(e);
    },
    localization: {
      locale: p || "en"
    },
    toolbar: l
  });
},
    ue = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 4
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 8
    }
  }
},
    oe = function oe(t) {
  var r = t.title,
      n = t.fields,
      a = t.onSubmit,
      p = t.loading,
      f = t.form,
      m = t.onCancel,
      x = t.translation,
      O = f.getFieldDecorator;
  return e.createElement(u, null, r, e.createElement(w, {
    onSubmit: function onSubmit(e) {
      e.preventDefault(), f.validateFields(function (e, t) {
        e || a(t);
      });
    },
    layout: "horizontal"
  }, n.map(function (t) {
    return Object.hasOwnProperty.call(t, "hidden") && t.hidden.includes("form") ? null : e.createElement(w.Item, F({
      key: t.key,
      label: t.title
    }, ue), function (t, r) {
      var n = {
        initialValue: t.value || t.initialValue || void 0
      };

      switch (t.type) {
        case "date":
          return r(t.key, L({}, n, {
            rules: t.rules
          }))(e.createElement(d, F({
            disabled: t.disabled || !1
          }, t.Context, t.props)));

        case "number":
          return r(t.key, L({}, n, {
            rules: t.rules
          }))(e.createElement(y, F({
            disabled: t.disabled || !1
          }, t.props)));

        case "bool":
          return r(t.key, L({}, n, {
            rules: t.rules,
            valuePropName: "checked",
            initialValue: Object.hasOwnProperty.call(t, "value") ? t.value : !!Object.hasOwnProperty.call(t, "initialValue") && t.initialValue
          }))(e.createElement(h, F({
            disabled: t.disabled || !1
          }, t.props)));

        case "radio":
          return r(t.key, L({}, n, {
            rules: t.rules
          }))(e.createElement(g.Group, F({
            disabled: t.disabled || !1
          }, t.props), Object.keys(t.options).map(function (r) {
            return e.createElement(g, {
              key: r,
              value: r
            }, t.options[r]);
          })));

        case "select":
          return r(t.key, L({}, n, {
            rules: t.rules
          }))(e.createElement(v, F({
            disabled: t.disabled || !1,
            mode: t.mode || !1,
            allowClear: !0
          }, t.props), Object.keys(t.options).map(function (r) {
            return e.createElement(v.Option, {
              key: r,
              value: r
            }, t.options[r]);
          })));

        case "password":
          return r(t.key, L({}, n, {
            rules: t.rules
          }))(e.createElement(c.Password, F({
            disabled: t.disabled || !1
          }, t.props)));

        case "textarea":
          return r(t.key, L({}, n, {
            rules: t.rules
          }))(e.createElement(c.TextArea, F({
            disabled: t.disabled || !1
          }, t.props)));

        case "rich":
          return r(t.key, L({}, n, {
            rules: t.rules
          }))(e.createElement(ae, {
            typeFormat: t.typeFormat,
            convertToRaw: t.convertToRaw,
            convertToDraft: t.convertToDraft,
            toolbar: t.toolbar || {}
          }));

        case "file":
          return r(t.key, L({}, n, {
            rules: t.rules
          }))(e.createElement(b, t.props, !t.props.multiple && t.props.fileList && t.props.fileList.length >= 1 ? null : e.createElement(s, null, e.createElement(l, {
            type: "upload"
          }), " ", t.textUpload)));

        case "cascader":
          return r(t.key, L({}, n, {
            rules: t.rules
          }))(e.createElement(k, {
            disabled: t.disabled || !1,
            fieldNames: {
              label: "name",
              value: "id",
              children: "subcategories"
            },
            options: Object.keys(t.options || {}).map(function (e) {
              return t.options[e];
            }),
            defaultValue: t.value,
            showSearch: {
              filter: function filter(e, t) {
                return t.some(function (t) {
                  return t.name.toLowerCase().indexOf(e.toLowerCase()) > -1;
                });
              }
            },
            placeholder: t.placeholder || ""
          }));

        default:
        case "string":
          return r(t.key, L({}, n, {
            rules: t.rules
          }))(e.createElement(c, F({
            disabled: t.disabled || !1
          }, t.props)));
      }
    }(t, O));
  }), e.createElement(o, {
    gutter: 8
  }, e.createElement(i, {
    sm: {
      span: 3,
      offset: 3
    },
    xs: {
      span: 24
    },
    className: "custom-align-right"
  }, e.createElement(s, {
    size: "large",
    className: "custom-full-width",
    onClick: function onClick() {
      f.resetFields(), m();
    }
  }, x("Cancel"))), e.createElement(i, {
    sm: {
      span: 3
    },
    xs: {
      span: 24
    }
  }, " ", e.createElement(s, {
    htmlType: "submit",
    type: "primary",
    size: "large",
    loading: p,
    className: "custom-full-width"
  }, x("Save"))))));
};

oe.defaultProps = {
  loading: !1,
  translation: function translation(e) {
    return e;
  }
};
var ie = w.create({
  onValuesChange: function onValuesChange(e, t, r) {
    e.onValuesChanged(e, t, r);
  }
})(oe);

function ce(t) {
  var r = t.client,
      n = t.type,
      a = t.children,
      u = t.localize;
  return e.createElement(D.Provider, {
    value: {
      client: r,
      type: n,
      localize: u
    }
  }, a);
}

export { ie as Form, re as List, ce as ProviderEasyCrud, H as fieldsToColumns, te as useCrudForm, J as useCrudList };